module.exports = __webpack_public_path__ + "img/B户型品鉴-右_image.50b99d28.png";